// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"tq-z","slideIn":"uq-z"};